import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getNoticeById, createNotice, updateNotice } from '../api/noticeApi'
import { appToast } from '../../../../components/AppToast'

export default function useNoticeEntry() {
  const { id } = useParams()
  const isEditMode = Boolean(id)
  const navigate = useNavigate()

  const [notice, setNotice] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isEditMode) {
      setLoading(true)
      getNoticeById(id)
        .then((data) => {
          setNotice(data.notice || '')
        })
        .catch((err) => {
          console.error(err)
          appToast.error('Notice entry not found.')
          navigate('/cloud/notice/list')
        })
        .finally(() => setLoading(false))
    }
  }, [id, isEditMode, navigate])

  const handleSave = async () => {
    if (!notice.trim()) {
      appToast.error('Please enter the notice content.')
      return
    }

    setIsSaving(true)
    try {
      if (isEditMode) {
        await updateNotice(id, notice.trim())
        appToast.success('Entry Saved Successfully')
      } else {
        await createNotice(notice.trim())
        appToast.success('Entry Saved Successfully')
      }
      navigate('/cloud/notice/list')
    } catch (e) {
      console.error('Failed to save notice', e)
      appToast.error('Error saving entry')
    } finally {
      setIsSaving(false)
    }
  }

  return {
    state: {
      isEditMode,
      loading,
      isSaving,
      notice,
    },
    actions: {
      setNotice,
      handleSave,
    },
  }
}
